// Everything the grid's components share about ONE answer, built once per answer. Pure; decides no state.
import type { HealthGridAsset, HealthMonitor, HealthResponse } from "./types";
import { assetById, entryLabel, placeGridChecks, type GridPlacement } from "./present";

export interface GridCtx {
  data: HealthResponse;
  byId: Map<string, HealthGridAsset>;
  /** which monitor each landed check is named after; the unplaced checks; anything the answer places nowhere */
  placement: GridPlacement;
  /** registry monitors first; an unregistered monitor only when no registry monitor has its id */
  monitorsById: Map<string, HealthMonitor>;
  /** primary asset id -> the consequent assets collapsed under it */
  consequentsOf: Map<string, HealthGridAsset[]>;
  labelOf: (id: string) => string;
}

export function buildGridCtx(data: HealthResponse): GridCtx {
  const byId = assetById(data);
  const monitorsById = new Map<string, HealthMonitor>();
  for (const m of [...data.monitors, ...data.unregistered_monitors]) if (!monitorsById.has(m.id)) monitorsById.set(m.id, m);
  const consequentsOf = new Map<string, HealthGridAsset[]>();
  for (const a of data.grid.assets) {
    if (a.role !== "consequent") continue;
    for (const p of a.collapsed_under) consequentsOf.set(p, [...(consequentsOf.get(p) ?? []), a]);
  }
  return { data, byId, placement: placeGridChecks(data), monitorsById, consequentsOf, labelOf: (id: string) => entryLabel(byId, id) };
}
